/** Mirrors server/constants/userRoleCatalog.js for UI labels */

export const USER_TYPES = {
  PUBLIC: 'public',
  MANAGED: 'managed',
};

export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  MODERATOR: 'moderator',
  ACCOUNT_MANAGER: 'account_manager',
  STORE_OWNER: 'store_owner',
};

export const ROLE_ORDER = [
  ROLES.SUPER_ADMIN,
  ROLES.ADMIN,
  ROLES.MODERATOR,
  ROLES.ACCOUNT_MANAGER,
  ROLES.STORE_OWNER,
];

const ROLE_LABELS = {
  super_admin: 'Super Admin',
  admin: 'Admin',
  moderator: 'Moderator',
  account_manager: 'Account Manager',
  store_owner: 'Store Owner',
};

export function roleLabel(role) {
  return ROLE_LABELS[role] || String(role || '').replace(/_/g, ' ');
}

export function userTypeLabel(userType) {
  if (userType === USER_TYPES.PUBLIC) return 'Public';
  if (userType === USER_TYPES.MANAGED) return 'Managed';
  return userType || '—';
}

export function isPlatformAdmin(role) {
  return role === ROLES.ADMIN || role === ROLES.SUPER_ADMIN;
}
